import * as actionTypes from "./actionTypes";

const initialState = {
  data: [],
  typeList: [],
  statusList: [],
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        typeList: action.payload.typeList,
        statusList: action.payload.statusList,
      };

    case actionTypes.DOWNLOAD_FULFILLED:
    case actionTypes.GET_REJECTED:
    case actionTypes.CREATE_REJECTED:
    case actionTypes.DOWNLOAD_REJECTED:
    case actionTypes.MODIFY_REJECTED:
    case actionTypes.DELETE_REJECTED:
    case actionTypes.UPLOAD_FULFILLED:
    case actionTypes.UPLOAD_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_FULFILLED:
    case actionTypes.MODIFY_FULFILLED:
    case actionTypes.DELETE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };

    case actionTypes.MODIFY:
    case actionTypes.CREATE:
    case actionTypes.GET:
    case actionTypes.DELETE:
    case actionTypes.DOWNLOAD:
    case actionTypes.UPLOAD:
      return { ...state, isLoading: true };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
